import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCrNt433szZCY7s1gTWkrns9L5IXPRT4QE",
  authDomain: "fbneu-3582c.firebaseapp.com",
  projectId: "fbneu-3582c",
  storageBucket: "fbneu-3582c.firebasestorage.app",
  messagingSenderId: "781943828022",
  appId: "1:781943828022:web:f66235515225758882b297",
  measurementId: "G-LGD6YPMCLC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

try {
  messaging = getMessaging(app);
} catch (error) {
  console.warn("Firebase messaging not available:", error.message);
}

// Request notification permission and get FCM token
export const getFirebaseToken = async () => {
  if (!messaging) {
    console.warn("Firebase messaging not initialized");
    return null;
  }

  try {
    // Check if notification permission is granted
    if (Notification.permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'YOUR_VAPID_KEY' // Replace with your VAPID key
      });
      return token;
    } else if (Notification.permission === 'default') {
      // Request permission
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: 'YOUR_VAPID_KEY' // Replace with your VAPID key
        });
        return token;
      } else {
        console.log("Notification permission denied by user");
        return null;
      }
    } else {
      console.log("Notification permission blocked by user");
      return null;
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

// Handle foreground messages
export const onMessageListener = () => {
  if (!messaging) {
    return new Promise((resolve) => {
      resolve(null);
    });
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};

export default app;